export default class CreateJobWorkerOfferRequest {
   jobWorkerId: string;
   annualSalary = 0;
   //expiryDate: Date;
   description = '';
   sendContactConfirmation = true;
}